export default __webpack_public_path__ + "static/media/IMG_2376_tn.1eb83a20.jpg";